import { WarningStatusType } from '@dpr-details/enums';
import { DprActivity } from '@shared/models/dpr';
import { ModifyIdentity } from '@grid/models';
import { GridSync } from '@grid/models';
import { DprActivityCustomDataGridData, DprSubActivityGridData } from '.';
import { DprAttachmentsGridData } from '@shared/models/grid';

export interface DprActivityGridData extends ModifyIdentity<DprActivity> {
  // inline custom data, data types
  [key: number]: string | number;

  status?: WarningStatusType;
  canBeDeleted?: boolean;
  dprSubActivities?: DprSubActivityGridData[];
  dprActivityCustomDataList?: DprActivityCustomDataGridData[];
  dprActivityAttachments?: DprAttachmentsGridData[];
  syncDprSubActivities?: GridSync<DprSubActivityGridData>;
  syncDprActivityCustomDataList?: GridSync<DprActivityCustomDataGridData>;
  syncDprActivityAttachments?: GridSync<DprAttachmentsGridData>;
}
